/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IYoutubeEmbedData } from './youtube-embed.data';
import { IYoutubeEmbedProps } from './youtube-embed.props.autogenerated';

export interface IYoutubeEmbedViewProps extends IYoutubeEmbedProps<IYoutubeEmbedData> {

}

/**
 *
 * YoutubeEmbed component
 * @extends {React.PureComponent<IYoutubeEmbedProps<IYoutubeEmbedData>>}
 */
class YoutubeEmbed extends React.PureComponent<IYoutubeEmbedProps<IYoutubeEmbedData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default YoutubeEmbed;
